import React from 'react';
import SchoolProgram2023 from 'views/SchoolProgram2023'

const SchoolProgrampage = () => {
  return <SchoolProgram2023 />;
};

export default SchoolProgrampage;